import React from 'react'
import './OrangeButton2.scss'

function OrangeButton2(props) {
    const handleBtnClick = () => {
        const contactPopup = document.querySelector('.contact-popup');
        if (contactPopup) {
          if (contactPopup.classList.contains('contact-popup-active')) {
            contactPopup.classList.remove('contact-popup-active');
          }
          else {
            contactPopup.classList.add('contact-popup-active');
          }
        }
      };
    
  
  return (
    <a href={props.href}>
    <button className='orange-button2' onClick={handleBtnClick}>
        <span className='button-text2'>{props.text}</span>
    </button>
    </a>
  )
}

export default OrangeButton2